import { Field } from 'formik';
import { FormControl, FormGroup, FormLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';
import InputFormGroup from '../util/InputFormGroup';

function StateFormGroup({ isStateRequired, supportedStatesList }) {
  const redStyle = { color: 'rgb(230, 0, 0)' };
  if (isStateRequired) {
    const states = supportedStatesList;
    if (states != null && states.length > 0) {
      const options = states.map((state) => (
        <option key={state} value={state}>
          {state}
        </option>
      ));

      return (
        <Field name="state">
          {({ field }) => (
            <FormGroup controlId={field.name}>
              <FormLabel>
                State <span style={redStyle}>*</span>
              </FormLabel>
              <FormControl as="select" {...field} required={isStateRequired}>
                {options}
              </FormControl>
            </FormGroup>
          )}
        </Field>
      );
    }
    return (
      <InputFormGroup name="state" label="State" required={isStateRequired} />
    );
  }

  return null;
}

StateFormGroup.propTypes = {
  isStateRequired: PropTypes.bool,
  supportedStatesList: PropTypes.array,
};
export default StateFormGroup;
